module.exports = __webpack_public_path__ + "static/media/icon_43.856b2cc6.svg";